import gql from 'graphql-tag';

export const benefitsQuery = gql`
  query benefits {
    benefits {
      raffles {
        ...RaffleFields
      }
      vouchers {
        ...VoucherFields
      }
    }
  }

  fragment RaffleFields on Raffle {
    id
    headline
    description {
      plaintext
    }
    images {
      main {
        url
        width
        height
      }
      secondary {
        url
        width
        height
      }
    }
    participation {
      registration
    }
    productRegistrationRequired
    eligible
    active
    startDateOfPurchaseDate
    endDateOfPurchaseDate
    afterSubmissionResponse {
      plaintext
    }
    endDateOfRaffle
    questions {
      id
      question
      required
      default
      type
      options {
        label
        value
      }
    }
  }

  fragment VoucherFields on Voucher {
    voucherCode
    title
    legalInformation
    images {
      main {
        url
        width
        height
      }
    }
    creationDate
    expirationDate
    status
    callToActionURL
  }
`;

export const benefitsLegalConditionsQuery = gql`
  query legalConditions {
    benefits {
      raffles {
        id
        termsAndConditions {
          html
        }
        privacyPolicy {
          html
        }
      }
      vouchers {
        promotionId
        legalInformation
      }
    }
  }
`;

export const enterRaffleMutation = gql`
  mutation enterRaffle($raffleId: String!, $newsletterConsent: Boolean, $answers: [Answer!]) {
    enterRaffle(input: { raffleId: $raffleId, newsletterConsent: $newsletterConsent, answers: $answers }) {
      raffleId
      participation {
        registration
      }
    }
  }
`;
